import {
  Avatar,
  Box,
  Divider,
  Menu,
  MenuItem,
  Typography,
} from '@atgfr8/atg-ui-tailwind';
import { LogoutIcon } from '@atgfr8/icons';
import { useNavigate } from '@solidjs/router';
import { userStore } from '@store/user';
import { LogUserOut } from '@store/user/actions';
import { ConfigManager } from '@utils/ConfigManager';
import { createSignal } from 'solid-js';

const avatarText = {
  color: 'white',
  fontSize: '14px',
};

export default function AccountMenu() {
  const [anchorEl, setAnchorEl] = createSignal<undefined | HTMLDivElement>(
    undefined,
  );
  const open = () => Boolean(anchorEl());
  const handleClose = () => setAnchorEl(undefined);

  const navigate = useNavigate();

  const handleMyAccountClick = () => {
    window.location.href = '/user/details';
    handleClose();
  };

  const handleLogoutClick = async () => {
    // Clearing everything from local storage and session storage
    // and redirecting to login page
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = `${ConfigManager.v3Host}/account/ClearStorage`;
    document.body.appendChild(iframe);
    await LogUserOut();
    setTimeout(() => {
      navigate(`/account/login?auth_url=${window.location.pathname}`);
    });
  };

  return (
    <>
      <Box
        class="flex flex-row items-center text-center gap-1 items-center h-[42px] cursor-pointer mr-1"
        title="Account settings"
        ref={setAnchorEl}
        aria-controls={open() ? 'account-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open() ? 'true' : undefined}
      >
        <Avatar size={28}>
          <Typography sxProps={avatarText} component="p" variant="body1">
            {userStore.user.name && userStore.user.name[0]}
          </Typography>
        </Avatar>
        <Typography sxProps={avatarText} component="p" variant="body1">
          {userStore.user.name}
        </Typography>
      </Box>
      <Menu
        anchorEl={anchorEl}
        class="mt-[-4px] overflow-visible filter-[drop-shadow(0px_2px_8px_rgba(0,0,0,0.32))] mt-1
          [&>ul>li>a]:flex! [&>ul>li>a]:items-center!
          [&>ul>li>a>.avatar]:w-8! [&>ul>li>a>.avatar]:h-8! [&>ul>li>a>.avatar]:ml-[-4px]! [&>ul>li>a>.avatar]:mr-1!
          [&>ul:before]:content-[''] [&>ul:before]:block! [&>ul:before]:absolute! [&>ul:before]:top-0!
          [&>ul:before]:right-[14px] [&>ul:before]:w-[10px] [&>ul:before]:h-[10px] [&>ul:before]:bg-white
          [&>ul:before]:translate-y-[-50%]! [&>ul:before]:rotate-45! [&>ul:before]:z-0!
          w-[180px]! right-0 mt-2 text-left bg-white"
      >
        <MenuItem onClick={handleMyAccountClick} class="w-[180px]! text-left">
          <Avatar /> My account
        </MenuItem>
        <Divider class="my-2!" />
        <MenuItem onClick={handleLogoutClick} class="w-[180px]! text-left">
          <span class="w-[32px]">
            <LogoutIcon size={20} />
          </span>
          Logout
        </MenuItem>
      </Menu>
    </>
  );
}
